// Builds a Google Maps URL for a restaurant so it opens the ACTUAL business listing.
// Priority: google_place_id → google_maps_url → name+address search → raw coordinates (last).

function validCoords(lat, lng) {
  const la = Number(lat);
  const lo = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(lo)) return false;
  if (la < -90 || la > 90 || lo < -180 || lo > 180) return false;
  if (la === 0 && lo === 0) return false;
  return true;
}

// Only accept https Google Maps share URLs (google.com/maps, maps.app.goo.gl, goo.gl).
export function isSafeGoogleMapsUrl(url) {
  if (typeof url !== "string") return false;
  const u = url.trim();
  if (!/^https:\/\//i.test(u)) return false;
  let host;
  try { host = new URL(u).hostname.toLowerCase(); } catch { return false; }
  const roots = ["google.com", "goo.gl"];
  return roots.some((d) => host === d || host.endsWith("." + d));
}

// Human-readable place query: "Name, Address, City, Srbija".
function textQuery(r) {
  const name = (r.name || "").trim();
  const address = (r.address || "").trim();
  if (!name && !address) return null;
  const parts = [name, address, (r.city || "").trim(), "Srbija"].filter(Boolean);
  return parts.join(", ");
}

export function restaurantMapsUrl(r) {
  if (!r) return null;

  // 1) Canonical Google Place identity — opens the exact business listing.
  const placeId = (r.google_place_id || "").trim();
  if (placeId) {
    const q = textQuery(r) || (r.name || "").trim() ||
      (validCoords(r.latitude, r.longitude) ? `${r.latitude},${r.longitude}` : "");
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}&query_place_id=${encodeURIComponent(placeId)}`;
  }

  // 2) A pasted Google Maps business/share URL — use directly.
  if (isSafeGoogleMapsUrl(r.google_maps_url)) {
    return r.google_maps_url.trim();
  }

  // 3) Name + full address text search (resolves to the business far better than coords).
  const q = textQuery(r);
  if (q) return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

  // 4) Raw coordinates — last resort only.
  if (validCoords(r.latitude, r.longitude)) {
    return `https://www.google.com/maps/search/?api=1&query=${r.latitude},${r.longitude}`;
  }
  return null;
}
